module.exports = __webpack_public_path__ + "static/media/felixfund-light.945b3218.png";